import {
  DELETE_DEVICE,
  DELETE_DEVICE_ERROR,
  GET_MY_DEVICES,
  GET_MY_DEVICES_ERROR,
  SET_DEVICE_ERROR,
  GET_DEVICE_COUNT,
  GET_DEVICE_COUNT_ERROR,
  GET_REGISTER_INFORMATION,
  GET_REGISTER_INFORMATION_ERROR,
  SET_CARRIERS,
  SET_CARRIER_PRODUCT_LIST,
  SET_RECHARGE_HISTORY,
} from '../actions/actionTypes';

export const initialState: reducers.DevicesState = {
  error: null,
  myDevices: null,
  deviceCount: null,
  lastNumbers: null,
  carriers: null,
  carrierProductList: null,
  rechargeHistory: null,
};

export type SetDeviceErrorAction = {
  type: string;
  payload: Error | null;
};

const deviceReducer = (state = initialState, action: SetDeviceErrorAction) => {
  const { payload, type } = action;
  switch (type) {
    case SET_DEVICE_ERROR:
      return {
        ...state,
        error: payload,
      };
    case GET_MY_DEVICES:
      return {
        ...state,
        myDevices: payload,
      };
    case GET_MY_DEVICES_ERROR:
      return {
        ...state,
        error: payload as Error,
      };
    case DELETE_DEVICE:
      return {
        ...state,
      };
    case DELETE_DEVICE_ERROR:
      return {
        ...state,
        error: payload as Error,
      };
    case GET_DEVICE_COUNT:
      return {
        ...state,
        deviceCount: payload,
      };
    case GET_DEVICE_COUNT_ERROR:
      return {
        ...state,
        error: payload as Error,
      };
    case GET_REGISTER_INFORMATION:
      return {
        ...state,
        lastNumbers: (payload as unknown as { lastNumbers: string })
          .lastNumbers,
      };
    case GET_REGISTER_INFORMATION_ERROR:
      return {
        ...state,
        error: payload as Error,
      };
    case SET_CARRIERS:
      return {
        ...state,
        carriers: payload,
      };
    case SET_CARRIER_PRODUCT_LIST:
      return {
        ...state,
        carrierProductList: payload,
      };
    case SET_RECHARGE_HISTORY:
      return {
        ...state,
        rechargeHistory: payload,
      };
    default:
      return state;
  }
};

export default deviceReducer;
